import React, { useEffect, useRef, useState } from "react";
import {
  APPEAL_ICON_BOX,
  CHEVRON_LEFT,
  CLOSE,
  DISMISSED_ICON_BOX,
  EMPTY_SEARCH_2,
  PENDING_ICON_BOX,
  PROFILE_ADD,
  SEARCH_ICON_BOX,
  USERS_GREEN,
} from "../../assets";
import { useQuery } from "react-query";
import {
  deleteCourtCase,
  getCourtAllCases,
  getCourtDashboardSummary,
} from "../../Services/court.services";
import ButtonV2 from "../../shared/components/buttonV2";
import TableComponent from "../../shared/components/table";
import {
  CASE_COLUMN,
  COURT_COLUMN,
} from "../../shared/components/table/columns";
import { SearchHistoryTypes } from "../../types";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  openCaseModal,
  selectCase,
  selectCaseFormModal,
  selectEditMode,
  setCaseDetailModal,
  setCaseFormModal,
  setDeleteModal,
  setEditMode,
  setSelectedCaseDetails,
  showDeleteModal,
} from "../../states/slices/globalReducer";
import CaseDetailsModal from "../../shared/components/casedetailsmodal";
import CaseFormModal, {
  FormFieldProps,
} from "../../shared/components/caseformModal";
import ModalV2 from "../../shared/components/modalV2";
import SuccessModal from "../../shared/components/successModal";
import CourtDetailsModal from "./courtdetailsModal";
import LinkHead from "../../shared/components/LinkHead";
import DeleteModal from "../../shared/components/deleteModal";
import toast from "react-hot-toast";
import CourtStaffCaseFormModal from "./uploadcasemodal";
import { Loader2 } from "lucide-react";

function CourtStaffDashboard() {
  const dispatch = useAppDispatch();
  const [uploadCaseModal, setUploadCaseModal] = useState(false);
  const caseFormModal = useAppSelector(selectCaseFormModal);
  const editMode = useAppSelector(selectEditMode);
  const deletModal = useAppSelector(showDeleteModal);
  const caseDetailModal = useAppSelector(openCaseModal);
  const caseDetails = useAppSelector(selectCase);
  const [success, setSuccess] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const { data: dashboardSummary } = useQuery(
    "court",
    getCourtDashboardSummary
  );
  const [currentPage, setCurrentpage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const {
    data: allCases,
    refetch,
    isLoading,
  } = useQuery(["cases", currentPage], () => getCourtAllCases(currentPage));
  const filterCases = allCases?.data?.filter((item: SearchHistoryTypes) =>
    item.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // const [formField, setFormField] = useState<FormFieldProps>({
  //   title: "",
  //   title_number: "",
  //   survey_plan_number: "",
  //   owner_name: "",
  //   address: "",
  //   parties: "",
  //   subject_matter: "",
  //   suit_number: "",
  //   court_details: "",
  //   date_of_commencement: "",
  //   date_of_disposal: "",
  //   name_of_parties: "",
  //   nature_of_case: "",
  //   judicial_division: "",
  //   description_of_properties: "",
  // });
  const pagesRefs = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    const selectedButton = pagesRefs.current[currentPage];
    if (selectedButton) {
      selectedButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, [currentPage]);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      const response = await deleteCourtCase(caseDetails?.id);
      if (response) {
        toast.success(response?.message);
        dispatch(setDeleteModal(false));
        refetch();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    dispatch(setSelectedCaseDetails(null));
    dispatch(setCaseFormModal(false));
  }, []);

  return (
    <div className="p-3 sm:p-5">
      <LinkHead title="Court Registrar - dashboard" content="" />
      <div className="flex items-start flex-col">
        <span className="text-[#2A2E34] font-semibold text-xl sm:text-2xl">
          Dashboard
        </span>
        <span className="text-primary-50 font-medium text-xs sm:text-sm">
          Dashboard Overview
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 w-full mt-5">
        <div className="w-full rounded-xl border border-borderColor p-3 flex items-start gap-x-2">
          <img
            src={SEARCH_ICON_BOX}
            className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
            alt=""
          />
          <div className="flex flex-col">
            <span className="text-xs font-medium text-primary-50">
              Total Searches
            </span>
            <span className="text-lg sm:text-xl font-bold text-customDark">
              {dashboardSummary?.total_searches}
            </span>
          </div>
        </div>
        <div className="w-full rounded-xl border border-borderColor p-3 flex items-start gap-x-2">
          <img
            src={PENDING_ICON_BOX}
            className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
            alt=""
          />
          <div className="flex flex-col">
            <span className="text-xs font-medium text-primary-50">
              Total Pending
            </span>
            <span className="text-lg sm:text-xl font-bold text-customDark">
              {dashboardSummary?.total_pending}
            </span>
          </div>
        </div>
        <div className="w-full rounded-xl border border-borderColor p-3 flex items-start gap-x-2">
          <img
            src={APPEAL_ICON_BOX}
            className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
            alt=""
          />
          <div className="flex flex-col">
            <span className="text-xs font-medium text-primary-50">
              Total Appeal
            </span>
            <span className="text-lg sm:text-xl font-bold text-customDark">
              {dashboardSummary?.total_on_appeal}
            </span>
          </div>
        </div>
        <div className="w-full rounded-xl border border-borderColor p-3 flex items-start gap-x-2">
          <img
            src={DISMISSED_ICON_BOX}
            className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0"
            alt=""
          />
          <div className="flex flex-col">
            <span className="text-xs font-medium text-primary-50">
              Total Dismissed
            </span>
            <span className="text-lg sm:text-xl font-bold text-customDark">
              {dashboardSummary?.total_concluded}
            </span>
          </div>
        </div>
      </div>

      <div className="w-full mt-5">
        {allCases?.data?.length > 0 ? (
          <div className="mt-2 border border-borderColor rounded-lg pb-5">
            <div className="overflow-x-auto">
              <TableComponent
                DATA={filterCases}
                //@ts-ignore
                COLUMNS={COURT_COLUMN}
              />
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-3 px-3 sm:px-5">
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  onClick={() =>
                    setCurrentpage(allCases?.meta?.current_page - 1)
                  }
                  disabled={allCases?.meta?.current_page === 1}
                  className="border border-[#EBEBEB] rounded-xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center disabled:opacity-50"
                >
                  <img
                    src={CHEVRON_LEFT}
                    className="w-4 h-4 sm:w-5 sm:h-5"
                    alt=""
                  />
                </button>

                <div className="flex items-center gap-x-1 sm:gap-x-2 max-w-[200px] overflow-x-auto">
                  {allCases?.meta?.links
                    ?.slice(1, -1)
                    .map((page: any, index: number) => (
                      <button
                        key={index}
                        ref={(el) => (pagesRefs.current[index] = el)}
                        onClick={() => {
                          page.url && setCurrentpage(Number(page.label));
                        }}
                        className={`flex items-center justify-center hover:bg-globalGold hover:text-white transition-all duration-300 min-w-[32px] h-[32px] sm:min-w-[40px] sm:h-[40px] rounded-xl text-xs sm:text-sm ${
                          page.active
                            ? "bg-globalGold text-white"
                            : "border text-[#2A2E34]"
                        }`}
                      >
                        {page.label}
                      </button>
                    ))}
                </div>

                <button
                  type="button"
                  onClick={() =>
                    setCurrentpage(allCases?.meta?.current_page + 1)
                  }
                  disabled={
                    allCases?.meta?.current_page === allCases?.meta?.last_page
                  }
                  className="border border-[#EBEBEB] rounded-xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center disabled:opacity-50"
                >
                  <img
                    src={CHEVRON_LEFT}
                    className="w-4 h-4 sm:w-5 sm:h-5 scale-x-[-1]"
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        ) : isLoading ? (
          <div className="flex items-center justify-center py-10">
            <Loader2 color="#9ca3af" size={30} className="animate-spin" />
          </div>
        ) : (
          <div className="flex flex-col gap-y-2 pb-5 justify-center items-center w-full px-4">
            <img
              src={EMPTY_SEARCH_2}
              className="w-24 h-20 sm:w-36 sm:h-30"
              alt=""
            />
            <span className="text-lg sm:text-xl font-bold text-customDark text-center">
              No Cases Yet
            </span>
            <span className="text-xs sm:text-sm font-medium text-primary-50 max-w-md text-center">
              You haven't Added any case yet. Click the button below to begin
              your first Case upload.
            </span>
            <button
              onClick={() => dispatch(setCaseFormModal(true))}
              className="w-fit hover:scale-95 transition-all duration-300 bg-globalGold px-4 sm:px-5 py-2 rounded-3xl flex items-center justify-center gap-x-2 mt-2"
            >
              <img src={PROFILE_ADD} className="w-4 h-4 sm:w-5 sm:h-5" alt="" />
              <span className="text-sm sm:text-base font-medium text-white">
                Add New Case
              </span>
            </button>
          </div>
        )}
      </div>

      <CourtDetailsModal
        open={caseDetailModal}
        close={() => dispatch(setCaseDetailModal(false))}
        caseDetails={caseDetails}
      />
      <CourtStaffCaseFormModal
        existingCaseDetails={caseDetails}
        open={caseFormModal || false}
        onSuccess={() => {
          setSuccess(true);
          refetch();
        }}
        close={() => dispatch(setCaseFormModal(false))}
      />

      <SuccessModal
        open={success}
        close={() => setSuccess(false)}
        action={() => {
          refetch();
          setSuccess(false);
          dispatch(setEditMode(false));
        }}
        message={`Case Successfully ${editMode ? "Updated" : "Added"}`}
        message2={`You have successfully  ${
          editMode ? "updated" : "added"
        } a case`}
      />
      <DeleteModal
        open={deletModal}
        close={() => dispatch(setDeleteModal(false))}
        deleteTitle={"Case Folder"}
        warningMessage={`the case "${caseDetails?.title}"`}
        lastmessage={"cases"}
        handleDelete={handleDelete}
        loading={deleting}
      />
    </div>
  );
}

export default CourtStaffDashboard;
